import { Button, LoadingSpinner } from "@/components/ui";
import { getUserSessionQueryOptions } from "@/lib/data/react-query/auth/auth";
import { useQueryClient } from "@tanstack/react-query";
import { signOut } from "aws-amplify/auth";
import { LogOutIcon } from "lucide-react";
import { useState } from "react";

const LogoutButton = () => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const queryClient = useQueryClient();

  const handleLogout = async () => {
    setIsLoggingOut(true);
    await signOut();
    await queryClient.cancelQueries();
    queryClient.clear();
    await queryClient.ensureQueryData(getUserSessionQueryOptions());
    setTimeout(() => {
      window.location.href = "/login";
      setIsLoggingOut(false);
    }, 250);
  };

  return (
    <Button variant="outline" onClick={handleLogout} aria-label="Logout">
      <LogOutIcon />
      {isLoggingOut ? <LoadingSpinner /> : <span>Logout</span>}
    </Button>
  );
};

export default LogoutButton;
